jQuery(document).ready(function ($) {

     document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });

    // Open new window outgoing URLs, ignoring snow blocks and sso links 
    $('a:not(.snowBlockLink, .quick-view, .csb-link, .same-tab-link, .logout-link, .section--contact-information, .learn-more-edd, .edd-exceptions)').attr('target', function() {
        if(this.host == location.host) 
          return '_self'
        else 
          return '_blank'
    });
  
    /*** Aria hidden elements focusable fix ***/
    $('.hero.flickity-enabled .slideshow__slide:not(.is-selected)').attr("aria-hidden", false);
    $('.hero.flickity-enabled .slideshow__slide:not(.is-selected) *').attr("aria-hidden", false);
    $('.wb-fp-carousel.flickity-enabled .carousel-cell:not(.is-selected)').attr("aria-hidden", false);
    $('.wb-fp-carousel.flickity-enabled .carousel-cell:not(.is-selected) *').attr("aria-hidden", false);
});
